import configs from '@/configs'
import moment from "moment"
import { sendErrorNotice } from '@/commons/utils';
import { currency } from "@/commons/currency";
import { display_date } from "@/commons/formater";
export function request_header(token) {
  return {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "accept": "application/json",
  };
}

export function request_payload(param) {
  let query = '';
  let q_params = [];
  if(param && (param.pagination || param.qObject || param.filter || param.quickFilter)) {
    const page = param.pagination && param.pagination.page ? param.pagination.page : 1
    const rowsPerPage = param.pagination && param.pagination.itemsPerPage ? param.pagination.itemsPerPage : 1000000
    const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
    const descending = param.pagination ? param.pagination.sortDesc[0] : 1
    const qObject = param.qObject ? Buffer.from(JSON.stringify({ qObject: param.qObject })).toString("base64") : '';
    const filter = param.filter && param.filter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.filter })).toString("base64") : '';
    const quickFilter = param.quickFilter && param.quickFilter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.quickFilter })).toString("base64") : '';
    q_params.push(`filter=${encodeURIComponent(filter)}&qObject=${encodeURIComponent(qObject)}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}&q=${encodeURIComponent(quickFilter)}`)
  }
  
  if(param) {
    var fields = []
    Object.keys(param).forEach((key) => {
      if(!['pagination', 'qObject', 'filter', 'quickFilter'].includes(key)) {
        fields.push(`${key}=${param[key] == null ? '' : param[key]}`)
      }
    });
    q_params.push(`${fields.join('&')}`);
  }
  query = `?${q_params.join('&')}`;
  return query;
}

export function request_list(endpoint, cb, $http, param, token) {
  const req = {
    headers: request_header(token)
  };
  
  const query = request_payload(param);

  $http.get(`${configs.API}/api/${endpoint}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
    }
  });
}

export function export_list(endpoint, cb, $http, param, token, func) {
  const req = {
    headers: request_header(token),
    responseType: 'blob'
  };
  func = func ? func : 'export'
  const query = request_payload(param)

  $http.get(`${configs.API}/api/${endpoint}/${func}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function export_detail(endpoint, cb, $http, id, token, func, errorCb) {
  const req = {
    headers: request_header(token),
    responseType: 'blob'
  };
  func = func ? func : 'export'

  $http.get(`${configs.API}/api/${endpoint}/${func}/${id}`, req).then(function (res) {
    setTimeout(() => cb(res), 100);
  }).catch(function (error) {
    console.error('Export error:', error);
    if (errorCb) {
      errorCb(error);
    } else {
      sendErrorNotice('Lỗi khi xuất file!');
    }
  });
}

export function import_list(endpoint, cb, $http, param, token, func) {
  const header = {
    headers: request_header(token)
  };
  header.headers['Content-Type'] = 'multipart/form-data';
  func = func ? func : 'import'

  $http.post(`${configs.API}/api/${endpoint}/${func}/`, param, header).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function request_detail(endpoint, cb, $http, id, token, param) {
  const header = {
    headers: request_header(token)
  };
  let query = '';
  if(param) {
    if(param.pagination) {
      const page = param.pagination ? param.pagination.page : 1
      const rowsPerPage = param.pagination ? param.pagination.itemsPerPage : 1000000
      const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
      const descending = param.pagination ? param.pagination.sortDesc[0] : 1
      query = `?page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}`;
      delete param.pagination;
    }
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = query == '' ? `?${fields.join('&')}` : `${query}&${fields.join('&')}`;
  }
  $http.get(`${configs.API}/api/${endpoint}/${id}${query}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
    }
  });
}

export function update_detail(endpoint, cb, $http, param, pId, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  let path = pId == 0 ? `${configs.API}/api/${endpoint}/` : `${configs.API}/api/${endpoint}/${pId}`;
  $http.post(path, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406 || err.status == 400) {
      sendErrorNotice(err.data.reason);
      setTimeout(() => cb(err), 100);
    }
  });
}

export function remove_detail(endpoint, cb, $http, id, token) {
  const header = {
    headers: request_header(token)
  };
  $http.delete(`${configs.API}/api/${endpoint}/${id}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
    }
  });
}

export function create_detail(endpoint, cb, $http, param, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  delete req['ID'];
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  $http.put(`${configs.API}/api/${endpoint}/`, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406 || err.status == 400) {
      sendErrorNotice(err.data.reason);
    }
  });
}

export function upload_file(endpoint, cb, $http, param, token, func) {
  const header = {
    headers: request_header(token)
  };
  header.headers['Content-Type'] = 'multipart/form-data';
  func = func ? func : 'import'

  $http.post(`${configs.API}/api/${endpoint}/${func}/`, param, header).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function comment_type(value) {
  const cmtType = configs.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.name : '';
}

export function comment_type_color(value) {
  const cmtType = configs.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.color : '#e6c87f';
}

export function comment_avatar(value) {
  if (value !== null) {
    return '/static/avatar/avatar.png';
  }
  return '/static/avatar/no_avatar.png';
}

export function comment_color(value) {
  if (value) {
    return '#ff0000';
  }
  return '#0000ff';
}

export function payment_type(value) {
  switch (value) {
    case 2:
    case 3:
      return "Đặt cọc";
    case 12:
      return "Hoàn tiền"
    default:
      return "Thanh toán";
  }
}

export function payment_type_color(value) {
  switch (value) {
    case 2:
      return "#e6c87f";
    case 3:
      return "#ffff00";
    case 12:
      return "#ff0000"
    default:
      return "#0000ff";
  }
}

export function complain_type(value) {
  switch (value) {
    case 1:
      return "Chờ xử lý";
    case 2:
      return "Đang xử lý";
    case 3:
      return "Đã xử lý"
    default:
      return "Đã hủy";
  }
}

export function complain_type_color(value) {
  switch (value) {
    case 1:
      return "#ff0000";
    case 2:
      return "#797960";
    case 3:
      return "#0000ff"
    default:
      return "#e6c87f";
  }
}

export function trade_type(value) {
  const cmtType = configs.TRADE_TYPE.find(obj => obj.value === value);
  return cmtType ? cmtType.name : '';
}

export function print_transaction(weight, transactionCode, customerName, orderId) {
  var mywindow = window.open("", "PRINT");

  mywindow.document.write("<html><head><title></title>");
  mywindow.document.write(
    "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
  );
  mywindow.document.write(
    ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
  );
  mywindow.document.write(
    ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 14px; font-weight: bold; font-style: italic; text-align: center;}"
  );
  mywindow.document.write(
    "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
  );
  mywindow.document.write("<div class='layout wrap'>");
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${customerName}</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><hr class='v-divider theme--light'></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${orderId}</p></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${weight} kg</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Mã vận đơn</p></div><div class='flex lg6'><p class='sub-title r-text'>${transactionCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
      new Date()
    ).format("DD-MM-YYYY")}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Lưu ý</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Qúy khách khi bóc hàng vui lòng giữ lại mã vận đơn Trung Quốc để sử dụng trong trường hợp Khiếu nại với nhà cung cấp</p></div>`
  );
  mywindow.document.write(`<hr class='v-divider theme--light'>`);
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>https://atlogistics.vn</p></div>`
  );
  mywindow.document.write("</div>");
  mywindow.document.write("</body></html>");

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  mywindow.close();
  return true;
}

export function print_truck_unload_list(truck, products) {
  let html_products = ''
  for (let i = 0; i < products.length; i++) {
    const p = products[i];
    html_products = html_products + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        <td class='body-text'>☐</td>
                        <td class='body-text'>${p.Code || ''}</td>
                        <td class='body-text'>${p.DirectName || ''}</td>
                        <td class='body-text'>${p.UserName || ''}</td>
                        <td class='body-text r-text'>${currency(p.Weight,'', 1)}</td>
                        <td class='body-text r-text'>${currency(p.Volume, '', 2)}</td>
                        <td class='body-text r-text'>${currency(p.OrderNumberOfPack,'',0)}</td>
                        <td class='body-text m-text' style='width: 80px;'></td>
                        <td class='body-text m-text'></td>
                      </tr>`
  }

  const print_content = `<html>
  <head>
      <title>Danh sách hàng trên xe</title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 18px; font-weight: bold; text-align: center; } .sub-title { font-size: 13px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .body-text { font-size: 13px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 3px; height: 36px } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; padding: 5px} @media print { @page { size: A4 landscape; margin: 10mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm; } } .no-boder {border: 0px !important;}
      </style>
  </head>
  
  <body style='font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text' colspan='2'><image src='/static/logo.png' height='40'/></td>
                <td class='no-boder title m-text' colspan='6'>DANH SÁCH HÀNG HÓA TRÊN XE</td>
                <td class='no-boder sub-title m-text' colspan='2'>Ngày ${moment().format('DD/MM/YYYY')}</td>
              </tr>	
              <tr>
                <td class='no-boder sub-title' colspan='3'>Biển số xe: <b>${truck.LicensePlate || ''}</b></td>
                <td class='no-boder sub-title' colspan='3'>Ngày xếp xe: <b>${truck.OrderDate ? display_date(truck.OrderDate) : ''}</b></td>
                <td class='no-boder sub-title' colspan='4'>Ngày nhập kho: <b>${truck.StoreDate ? display_date(truck.StoreDate) : ''}</b></td>
              </tr>
              <tr>
                <td class='no-boder sub-title' colspan='3'>Tổng cân: <b>${currency(truck.Weight || 0, '', 1)} kg</b></td>
                <td class='no-boder sub-title' colspan='3'>Tổng khối: <b>${currency(truck.Volume || 0, '', 2)} m³</b></td>
                <td class='no-boder sub-title' colspan='4'>Tổng mã: <b>${currency(truck.NumberOfProduct || 0, '', 0)}</b></td>
              </tr>
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text' style='width: 30px;'>STT</td>
                  <td class='sub-title m-text' style='width: 30px;'>✓</td>
                  <td class='sub-title m-text'>Mã HN</td>
                  <td class='sub-title m-text'>Điều hướng</td>
                  <td class='sub-title m-text'>Mã KH</td>
                  <td class='sub-title m-text'>Cân (kg)</td> 
                  <td class='sub-title m-text'>Khối (m³)</td> 
                  <td class='sub-title m-text'>Số kiện</td>
                  <td class='sub-title m-text'>Hạ thực tế</td>
                  <td class='sub-title m-text'>Ghi chú</td>
              </tr>
              ${html_products}
              <tr>
                <td class='sub-title m-text' colspan='5'>Tổng số</td>
                <td class='sub-title r-text'>${currency(_.sumBy(products, 'Weight'),'',1)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(products, 'Volume'),'',2)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(products, 'OrderNumberOfPack'),'',0)}</td>
                <td class='sub-title m-text' colspan='2'></td>
              </tr> 
              <tr>
                  <td class='no-boder body-text' colspan='10'><i>Ghi chú: Đánh dấu vào ô "✓" khi hạ hàng thành công. Ghi số kiện thực tế hạ vào cột "Hạ thực tế"</i></td>
              </tr> 
              <tr>
                  <td class='no-boder sub-title m-text' colspan='3'>Người giao<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='3'>Thủ kho<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='4'>Kế toán<br/><i>(Ký, ghi rõ họ tên)</i></td>
              </tr> 
              </table>
            </div>
        </body>
  </html>`;
  
  var mywindow = window.open("", "PRINT");
  mywindow.document.write(print_content);
  mywindow.document.close();
  mywindow.focus();
  mywindow.print();
  return true;
}

export function print_export_receipt_order(item, packages, render = false) {
  let html_packages = ''
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];
    html_packages = html_packages + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        <td class='body-text'>${p.TransactionCode}</td>
                        <td class='body-text r-text'>${currency(p.Weight,'', 1)}</td>
                        <td class='body-text r-text'>${currency(p.Volume, '', 2)}</td>
                        <td class='body-text r-text'>${currency(p.NumberOfPack,'',0)}</td>
                        <td class='body-text m-text'></td>
                      </tr>`
  }

  let contact_info = `<tr><td class='no-boder sub-title'>Người nhận: ${item.Receiver}</td></tr>
                      <tr><td class='no-boder sub-title'>Điện thoại: ${item.Phone}</td></tr>
                      <tr><td class='no-boder sub-title' colspan='2'>Người nhận hàng: ${item.Address}</td></tr>`
  let finance = ''

  const print_content = `<html>
  <head>
      <title>Phiếu xuất kho</title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 11px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 11px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:210mm;font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text'><image src='/static/logo.png'/></td>
                <td class='no-boder title m-text'>DHD LOGISTICS<br/>PHIẾU XUẤT KHO</td>
              </tr>	
              <tr>
                <td class='no-boder body-text m-text'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr>	
              ${contact_info}
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text'>STT</td>            
                  <td class='sub-title m-text'>Mã vận đơn</td>
                  <td class='sub-title m-text'>Cân nặng (kg)</td> 
                  <td class='sub-title m-text'>Kích thước (m³)</td> 
                  <td class='sub-title m-text'>Số kiện</td>
                  <td class='sub-title m-text'>Ghi chú</td>
              </tr>
              ${html_packages}
              <tr>
                <td class='sub-title m-text' colspan='2'>Tổng số</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Weight'),'',1)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Volume'),'',2)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'NumberOfPack'),'',0)}</td>
                <td class='sub-title m-text'></td>
              </tr> 
              ${finance}
              <tr>
                  <td class='no-boder body-text' colspan='6'><i>Quý khách vui lòng kiểm tra lại mã hàng, số lượng, khối lượng khi nhận hàng!</i></td>
              </tr> 
              <tr>
                  <td class='no-boder body-text' colspan='6'>Chứng từ, giấy tờ kèm theo:</td>
              </tr> 
              <tr>
              </tr> 
              <tr>
                  <td class='no-boder sub-title m-text' colspan='2'>Người giao<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='2'>Người nhận<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='2'>Người lập phiếu<br/><i>(Ký, ghi rõ họ tên)</i></td>
              </tr> 
              </table>
            </div>
        </body>
  </html>`;
  if(render) {
    return print_content;
  }
  var mywindow = window.open("", "PRINT");
  mywindow.document.write(print_content);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  // mywindow.close();
  return true;
}

export function print_bill(bill, products) {
  let html_products = ''
  let totalPacks = 0;
  let totalWeight = 0;
  let totalVolume = 0;
  
  for (let i = 0; i < products.length; i++) {
    const p = products[i];
    const packs = p.BillNumberOfPack || p.ExportPack || 0;
    const weight = p.Weight || 0;
    const volume = p.Volume || 0;
    
    totalPacks += packs;
    totalWeight += weight;
    totalVolume += volume;
    
    html_products = html_products + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        <td class='body-text'>${bill.BillCode || ''}</td>
                        <td class='body-text'>${p.Code || ''}</td>
                        <td class='body-text r-text'>${currency(packs,'',0)}</td>
                        <td class='body-text r-text'>${currency(weight,'', 1)}</td>
                        <td class='body-text r-text'>${currency(volume, '', 3)}</td>
                        <td class='body-text m-text'>-</td>
                        <td class='body-text m-text'>-</td>
                      </tr>`
  }

  const print_content = `<html>
  <head>
      <title>Phiếu xuất hàng ${bill.BillCode || ''}</title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 18px; font-weight: bold; text-align: center; } .sub-title { font-size: 13px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .body-text { font-size: 13px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 3px; height: 36px } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; padding: 5px} @media print { @page { size: A4; margin: 10mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm; } } .no-boder {border: 0px !important;} .signature-section { margin-top: 50px; }
      </style>
  </head>
  
  <body style='font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text' colspan='2'><image src='/static/logo.png' height='40'/></td>
                <td class='no-boder title m-text' colspan='4'>PHIẾU XUẤT HÀNG</td>
                <td class='no-boder sub-title m-text' colspan='2'>Ngày ${moment().format('DD/MM/YYYY')}</td>
              </tr>	
              <tr>
                <td class='no-boder sub-title' colspan='4'>Mã bill: <b>${bill.BillCode || ''}</b></td>
                <td class='no-boder sub-title' colspan='4'>Khách hàng: <b>${bill.CustomerFullName || ''} (${bill.CustomerUserName || ''})</b></td>
              </tr>
              <tr>
                <td class='no-boder sub-title' colspan='8'>Địa chỉ giao hàng: <b>${bill.DeliveryAddress || ''}</b></td>
              </tr>
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text' style='width: 40px;'>STT</td>
                  <td class='sub-title m-text'>Mã bill</td>
                  <td class='sub-title m-text'>Mã HN</td>
                  <td class='sub-title m-text'>Số kiện</td>
                  <td class='sub-title m-text'>Cân (kg)</td> 
                  <td class='sub-title m-text'>Khối (m³)</td>
                  <td class='sub-title m-text'>Phí khác</td>
                  <td class='sub-title m-text'>Cước giao</td>
              </tr>
              ${html_products}
              <tr>
                <td class='sub-title m-text' colspan='3'>TỔNG CỘNG HÀNG HÓA</td>
                <td class='sub-title r-text'>${currency(totalPacks,'',0)}</td>
                <td class='sub-title r-text'>${currency(totalWeight,'',1)}</td>
                <td class='sub-title r-text'>${currency(totalVolume,'',3)}</td>
                <td class='sub-title m-text'>-</td>
                <td class='sub-title m-text'>-</td>
              </tr>
              <tr>
                  <td class='no-boder' colspan='8'>&nbsp;</td>
              </tr>
              <tr>
                  <td class='no-boder sub-title m-text' colspan='2'>Thủ kho<br/><i>(Ký, ghi rõ họ tên)</i><br/><br/><br/><br/></td>
                  <td class='no-boder sub-title m-text' colspan='3'>Lái xe<br/><i>(Ký, ghi rõ họ tên)</i><br/><br/><br/><br/></td>
                  <td class='no-boder sub-title m-text' colspan='3'>Khách hàng<br/><i>(Ký, ghi rõ họ tên)</i><br/><br/><br/><br/></td>
              </tr>
              </table>
            </div>
        </body>
  </html>`;
  
  var mywindow = window.open("", "PRINT");
  mywindow.document.write(print_content);
  mywindow.document.close();
  
  // Đợi ảnh QR code load xong trước khi in
  const qrImage = mywindow.document.querySelector('img[alt="QR thanh toán"]');
  if (qrImage) {
    if (qrImage.complete) {
      // Ảnh đã load sẵn
      mywindow.focus();
      mywindow.print();
    } else {
      // Đợi ảnh load xong
      qrImage.onload = function() {
        mywindow.focus();
        mywindow.print();
      };
      // Xử lý trường hợp ảnh lỗi
      qrImage.onerror = function() {
        console.warn('QR image failed to load');
        mywindow.focus();
        mywindow.print();
      };
    }
  } else {
    // Không có ảnh QR, in ngay
    mywindow.focus();
    mywindow.print();
  }
  return true;
}